import { Label } from '@playbooks/ui/components/label'
import { Switch } from '@playbooks/ui/components/switch'
import { ReactNode } from 'react'

interface SwitchProps {
  id?: string
  className?: string
  wrapperClassName?: string
  onClick?: () => void
  checked?: boolean
  text?: ReactNode
  name?: string
  onChange?: (checked: boolean) => void
}

const CustomSwitch = ({ id, checked, text, onChange }: SwitchProps) => {
  return (
    <span className="flex items-center gap-2">
      <Switch id={id} checked={checked} onCheckedChange={onChange} />
      <Label className="text-sm" htmlFor={id}>
        {text}
      </Label>
    </span>
  )
}

export default CustomSwitch
